import { TextAreaResizable } from "@/Common/Components/Inputs/TextAreaResizable";
import { Popup } from "@/Common/Components/Modals/Popup";
import { Patient } from "@/Common/Models/Patient/Patient";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientUIModel } from "@/Patient/Models/UI/IPatientUIModel";
import { PatientMemoState } from "./PatientMemoPopup";

interface IPatientDeactivatePopupProps {
    PatientId: string;
    Model: IPatientUIModel;
    PatientModel: Patient;
}

class PatientDeactivatePopPopup extends React.Component<IPatientDeactivatePopupProps, any> {
    private id: string = "popupmenu";

    constructor(props: IPatientDeactivatePopupProps) {
        super(props);

        const patientIndividualResponse = patientStore.PatientModels[this.props.PatientId].IndividualResponse;
        const initialState = new PatientMemoState();
        initialState.MemoDate = patientIndividualResponse.MemoLastModifiedDate;
        initialState.MemoText = patientIndividualResponse.MemoNote ? patientIndividualResponse.MemoNote : "";
        initialState.MemoUserId = patientIndividualResponse.LastModifiedMemoEmployeeId;
        this.state = initialState;
    }

    public render(): JSX.Element {
        var canDeactivate: boolean = this.props.Model.get("SelectedDeactivationReasonLookupId").length > 0 || this.props.PatientModel.InactivableResponse.IsInactive;
        var title = this.props.PatientModel.InactivableResponse.IsInactive ? cacheStore.GetString("ReActivatePatientLabel") : cacheStore.GetString("DeactivatePatientLabel");

        return (
            <Popup
                Id={this.id}
                title={title}
                closeTarget={LocalPatientOperations.Profile.DeactivatePatientCancelClick}
                draggable
                manageOverlay
                cssClass="memo"
            >
                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                {!this.props.PatientModel.InactivableResponse.IsInactive && (
                                    <div className="col-sm-12">
                                        <strong className="form-label"> {cacheStore.GetString("DeactivatePatientMessageLabel")} </strong>
                                    </div>
                                )}
                                {this.props.PatientModel.InactivableResponse.IsInactive && (
                                    <div className="col-sm-12">
                                        <strong className="form-label"> {cacheStore.GetString("ReActivationMessage")} </strong>
                                    </div>
                                )}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    &nbsp; &nbsp; &nbsp;
                                </div>
                            </div>

                            {!this.props.PatientModel.InactivableResponse.IsInactive && (
                                <div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label className="form-label">{cacheStore.GetString("ReasonLabel")}</label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-12">
                                            <select onChange={e => this.OnReasonChange(e)} className="form-control myle-control" value={this.props.Model.get("SelectedDeactivationReasonLookupId")}>
                                                <option key="" value="" />
                                                {this.props.Model.get("AvailableDeactivationReasonLookupIds").toArray().map(reason => (
                                                    <option key={reason.LookupID} value={reason.LookupID}>{cacheStore.GetLocalizedValueByLookupId(reason.LookupID)}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            &nbsp; &nbsp; &nbsp;
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label className="form-label">{cacheStore.GetString("NotesLabel")}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <TextAreaResizable
                                                setCursorStartOnFocus={false}
                                                id="deactivateNote"
                                                text={this.props.Model.get("DeactivationNote")}
                                                isDisabled={false}
                                                onChange={value => this.DeactivationNoteChange(value)}
                                                resetTextOnIdChange={true}
                                            />

                                        </div>
                                    </div>

                                </div>
                            )}

                            {this.props.PatientModel.InactivableResponse.IsInactive && (
                                <div className="row">
                                    <div className="col-sm-12">
                                        <span> {cacheStore.GetLocalizedValueByLookupId(this.props.PatientModel.InactivableResponse.ReasonForInactivityLookupId)} </span>
                                        {this.props.PatientModel.InactivableResponse && this.props.PatientModel.InactivableResponse.InactivationNote && this.props.PatientModel.InactivableResponse.InactivationNote.length > 0 &&
                                            <span>({this.props.PatientModel.InactivableResponse.InactivationNote}) </span>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <div>
                                    <button data-action="cancel" className="btn btn-default push-right-5" onClick={e => this.CancelClick(e)}>{cacheStore.GetString("CancelLabel")}</button>
                                    <button data-action="save" disabled={!canDeactivate} className="btn btn-primary push-right-5" onClick={e => this.SaveClick(e)}>{cacheStore.GetString("ContinueLabel")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private DeactivationNoteChange(value: string): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.DeactivatePatientNoteChange);
        operation.AddItem("value", value);
        LocalEventDispatcher.dispatch(operation);
    }

    private CancelClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.DeactivatePatientCancelClick);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private OnReasonChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.DeactivatePatientReasonChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private SaveClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalPatientOperations.Profile.DeactivatePatientSaveClick);
        operation.AddItem("value", this.state.MemoText);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PatientDeactivatePopPopup };
